const archivedMessages = {
  custom_fields_archived_field:
    "This Additional Details field is archived and can't accept values.",
  custom_fields_archived_option: "An archived option can't be selected.",
};

const archivedMessage = (failure) =>
  failure?.status === 422 && Object.hasOwn(archivedMessages, failure?.code)
    ? archivedMessages[failure.code]
    : null;

export const requiresAdditionalDetailsReload = (failure) =>
  !!(failure?.uncertain || failure?.status === 409 || archivedMessage(failure));

export const saveFailureMessage = (failure) => {
  if (failure?.uncertain) {
    return "We couldn't confirm whether Additional Details were saved. Reload to check before saving again.";
  }
  if (archivedMessage(failure)) {
    return archivedMessage(failure);
  }
  if (failure?.status === 409) {
    return "This contact's Additional Details changed since you opened them. Reload and try again.";
  }
  return "We couldn't save Additional Details. Your changes are still here; try again.";
};
